import { usePage } from '@inertiajs/react';
import { rem } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconError404 } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next';

export const mutateAdDelete = (initParams) => {
    // Status messages in the user's language, not the server's English text.
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: ['ad-delete', initParams],
        mutationFn: async (formData = []) => {
            const res = await axios.delete(route('studio.v1.api.ads.bulk-destroy'), {
                data: { ...initParams, ...formData },
            });
            return res;
        },
        onSuccess: async ({ data }) => {

            notifications.show({
                color: 'green',
                title: t('ads.toast.deleted'),
            })

        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: t('common.error'),
                message: response?.data?.message || "",
            })
        }
    });

    return mutation;
}